// extracted by mini-css-extract-plugin
export default {"title":"R_-z","warning":"S_-z","sizeOptionsLegendText":"T_-z"};